const ADDRESS_BLUR_FIELD_DELAY = 250;

export default {
  ADDRESS_BLUR_FIELD_DELAY
};